import { render } from "./ShipInfo.vue?vue&type=template&id=07ecd40c&scoped=true"
import script from "./ShipInfo.vue?vue&type=script&lang=js"
export * from "./ShipInfo.vue?vue&type=script&lang=js"

import "./ShipInfo.vue?vue&type=style&index=0&id=07ecd40c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ecd40c"]])

export default __exports__